import type { McpOAuthDecisionRequest, McpOAuthDecisionResponse } from '@dawn/feature-config';
import { useMutation } from '@tanstack/react-query';

import { mcpOAuthApi } from '@/lib/api';

/** POST /mcp/oauth/decision — the consent answer; the response says where the browser goes. */
export function useMcpOAuthDecision() {
  return useMutation<McpOAuthDecisionResponse, Error, McpOAuthDecisionRequest>({
    mutationFn: (body) => mcpOAuthApi.decide(body),
  });
}
